module.exports = __webpack_public_path__ + "img/NO937904029.01208f2c.png";